var exports = {
  "aw": "x43aef4ae--b8501c--slider",
  "x$": "x43aef4ae--b8501c--slider-list",
};

module.exports = exports;
